import { PpHttpConfig } from '@penpencil/common';
import {
    COMMON_CONFIG,
    BASE_URLs,
    ENVIRONMENT_VARIABLES_STAGING,
} from './environment.shared';

const apiConfig: PpHttpConfig = {
    baseUrl: BASE_URLs.staging,
    ...COMMON_CONFIG,
};

export const environment = {
    production: false,
    apiConfig,
    ...ENVIRONMENT_VARIABLES_STAGING,
};
